export const hasTruthy = path => obj => obj && path && obj[path];
